<div *ngIf="isVisible" id="loader" class="loader-wrapper" data-e2e-id="xux-loader">
  <div class="closer" (click)="close()"></div>
  <div>
    <div id="loader-inner">
      <div class="genius-loader"
           style="position: relative; width: 100%; height: 100%; transform: scale(0.5); display: none;">
        <div class="orbiter" style="animation-delay: calc(0.006s * 1)">
          <div class="trail-particle" style="background: #262AFF; animation-delay: calc(0.006s * 1);"></div>
        </div>
        <div class="orbiter" style="animation-delay: calc(0.006s * 2)">
          <div class="trail-particle" style="background: #262AFF; animation-delay: calc(0.006s * 2);"></div>
        </div>
        <div class="orbiter" style="animation-delay: calc(0.006s * 3)">
          <div class="trail-particle" style="background: #262AFF; animation-delay: calc(0.006s * 3);"></div>
        </div>
        <div class="orbiter" style="animation-delay: calc(0.006s * 4)">
          <div class="trail-particle" style="background: #262AFF; animation-delay: calc(0.006s * 4);"></div>
        </div>
        <div class="orbiter" style="animation-delay: calc(0.006s * 5)">
          <div class="trail-particle" style="background: #262AFF; animation-delay: calc(0.006s * 5);"></div>
        </div>
        <div class="orbiter" style="animation-delay: calc(0.006s * 6)">
          <div class="trail-particle" style="background: #262AFF; animation-delay: calc(0.006s * 6);"></div>
        </div>
        <div class="orbiter" style="animation-delay: calc(0.006s * 7)">
          <div class="trail-particle" style="background: #262AFF; animation-delay: calc(0.006s * 7);"></div>
        </div>
        <div class="orbiter" style="animation-delay: calc(0.006s * 8)">
          <div class="trail-particle" style="background: #262AFF; animation-delay: calc(0.006s * 8);"></div>
        </div>
        <div class="orbiter" style="animation-delay: calc(0.006s * 9)">
          <div class="trail-particle" style="background: #262AFF; animation-delay: calc(0.006s * 9);"></div>
        </div>
        <div class="orbiter" style="animation-delay: calc(0.006s * 10)">
          <div class="trail-particle" style="background: #262AFF; animation-delay: calc(0.006s * 10);"></div>
        </div>
        <div class="orbiter" style="animation-delay: calc(0.006s * 11)">
          <div class="trail-particle" style="background: #262AFF; animation-delay: calc(0.006s * 11);"></div>
        </div>
        <div class="orbiter" style="animation-delay: calc(0.006s * 12)">
          <div class="trail-particle" style="background: #262AFF; animation-delay: calc(0.006s * 12);"></div>
        </div>
        <div class="orbiter" style="animation-delay: calc(0.006s * 13)">
          <div class="trail-particle" style="background: #262AFF; animation-delay: calc(0.006s * 13);"></div>
        </div>
        <div class="orbiter" style="animation-delay: calc(0.006s * 14)">
          <div class="trail-particle" style="background: #262AFF; animation-delay: calc(0.006s * 14);"></div>
        </div>
        <div class="orbiter" style="animation-delay: calc(0.006s * 15)">
          <div class="trail-particle" style="background: #262AFF; animation-delay: calc(0.006s * 15);"></div>
        </div>
        <div class="orbiter" style="animation-delay: calc(0.006s * 16)">
          <div class="trail-particle" style="background: #262AFF; animation-delay: calc(0.006s * 16);"></div>
        </div>
        <div class="orbiter" style="animation-delay: calc(0.006s * 17)">
          <div class="trail-particle" style="background: #2B2FFF; animation-delay: calc(0.006s * 17);"></div>
        </div>
        <div class="orbiter" style="animation-delay: calc(0.006s * 18)">
          <div class="trail-particle" style="background: #2B2FFF; animation-delay: calc(0.006s * 18);"></div>
        </div>
        <div class="orbiter" style="animation-delay: calc(0.006s * 19)">
          <div class="trail-particle" style="background: #2B2FFF; animation-delay: calc(0.006s * 19);"></div>
        </div>
        <div class="orbiter" style="animation-delay: calc(0.006s * 20)">
          <div class="trail-particle" style="background: #2B2FFF; animation-delay: calc(0.006s * 20);"></div>
        </div>
        <div class="orbiter" style="animation-delay: calc(0.006s * 21)">
          <div class="trail-particle" style="background: #2B2FFF; animation-delay: calc(0.006s * 21);"></div>
        </div>
        <div class="orbiter" style="animation-delay: calc(0.006s * 22)">
          <div class="trail-particle" style="background: #2B2FFF; animation-delay: calc(0.006s * 22);"></div>
        </div>
        <div class="orbiter" style="animation-delay: calc(0.006s * 23)">
          <div class="trail-particle" style="background: #3336FF; animation-delay: calc(0.006s * 23);"></div>
        </div>
        <div class="orbiter" style="animation-delay: calc(0.006s * 24)">
          <div class="trail-particle" style="background: #3336FF; animation-delay: calc(0.006s * 24);"></div>
        </div>
        <div class="orbiter" style="animation-delay: calc(0.006s * 25)">
          <div class="trail-particle" style="background: #3336FF; animation-delay: calc(0.006s * 25);"></div>
        </div>
        <div class="orbiter" style="animation-delay: calc(0.006s * 26)">
          <div class="trail-particle" style="background: #3336FF; animation-delay: calc(0.006s * 26);"></div>
        </div>
        <div class="orbiter" style="animation-delay: calc(0.006s * 27)">
          <div class="trail-particle" style="background: #383BFF; animation-delay: calc(0.006s * 27);"></div>
        </div>
        <div class="orbiter" style="animation-delay: calc(0.006s * 28)">
          <div class="trail-particle" style="background: #383BFF; animation-delay: calc(0.006s * 28);"></div>
        </div>
        <div class="orbiter" style="animation-delay: calc(0.006s * 29)">
          <div class="trail-particle" style="background: #4043FF; animation-delay: calc(0.006s * 29);"></div>
        </div>
        <div class="orbiter" style="animation-delay: calc(0.006s * 30)">
          <div class="trail-particle" style="background: #4043FF; animation-delay: calc(0.006s * 30);"></div>
        </div>
        <div class="orbiter" style="animation-delay: calc(0.006s * 31)">
          <div class="trail-particle" style="background: #474AFF; animation-delay: calc(0.006s * 31);"></div>
        </div>
        <div class="orbiter" style="animation-delay: calc(0.006s * 32)">
          <div class="trail-particle" style="background: #474AFF; animation-delay: calc(0.006s * 32);"></div>
        </div>
        <div class="orbiter" style="animation-delay: calc(0.006s * 33)">
          <div class="trail-particle" style="background: #4F52FF; animation-delay: calc(0.006s * 33);"></div>
        </div>
        <div class="orbiter" style="animation-delay: calc(0.006s * 34)">
          <div class="trail-particle" style="background: #4F52FF; animation-delay: calc(0.006s * 34);"></div>
        </div>
        <div class="orbiter" style="animation-delay: calc(0.006s * 35)">
          <div class="trail-particle" style="background: #5457FF; animation-delay: calc(0.006s * 35);"></div>
        </div>
        <div class="orbiter" style="animation-delay: calc(0.006s * 36)">
          <div class="trail-particle" style="background: #5457FF; animation-delay: calc(0.006s * 36);"></div>
        </div>
        <div class="orbiter" style="animation-delay: calc(0.006s * 37)">
          <div class="trail-particle" style="background: #5457FF; animation-delay: calc(0.006s * 37);"></div>
        </div>
        <div class="orbiter" style="animation-delay: calc(0.006s * 38)">
          <div class="trail-particle" style="background: #5457FF; animation-delay: calc(0.006s * 38);"></div>
        </div>
        <div class="orbiter" style="animation-delay: calc(0.006s * 39)">
          <div class="trail-particle" style="background: #5457FF; animation-delay: calc(0.006s * 39);"></div>
        </div>
        <div class="orbiter" style="animation-delay: calc(0.006s * 40)">
          <div class="trail-particle" style="background: #5457FF; animation-delay: calc(0.006s * 40);"></div>
        </div>
        <div class="orbiter" style="animation-delay: calc(0.006s * 41)">
          <div class="trail-particle" style="background: #5457FF; animation-delay: calc(0.006s * 41);"></div>
        </div>
        <div class="orbiter" style="animation-delay: calc(0.006s * 42)">
          <div class="trail-particle" style="background: #5457FF; animation-delay: calc(0.006s * 42);"></div>
        </div>
        <div class="orbiter" style="animation-delay: 0s">
          <div class="ping-shadow"></div>
        </div>
        <div class="orbiter" style="animation-delay: 0s">
          <div class="ping-ball"></div>
        </div>
      </div>

      <svg class="xenial-loader" viewBox="0 0 444 283.6">
        <g>
          <path
            stroke-linecap="round"
            stroke-width="30"
            stroke="#DDDDDD"
            class="st0 gray-anim"
            d="M342.7,95.1C338.1,52.9,302.4,20,258.9,20c-43.8,0-79.8,33.5-83.9,76.3c-4.6-0.8-9.4-1.2-14.2-1.2 c-36.9,0-68.3,23.8-79.7,56.8c-1.7-0.2-3.4-0.2-5.2-0.2c-30.9,0-56,25.1-56,56c0,29.2,22.3,53.1,50.8,55.7c0,0,266.2,0.2,268.9,0.2 c46.5,0,84.3-37.7,84.3-84.3C424,133.7,387.9,96.7,342.7,95.1z"
          ></path>
          <path
            stroke-linecap="round"
            stroke-width="30"
            stroke="#9cc568"
            class="st0 green-anim"
            d="M342.7,95.1C338.1,52.9,302.4,20,258.9,20c-43.8,0-79.8,33.5-83.9,76.3c-4.6-0.8-9.4-1.2-14.2-1.2 c-36.9,0-68.3,23.8-79.7,56.8c-1.7-0.2-3.4-0.2-5.2-0.2c-30.9,0-56,25.1-56,56c0,29.2,22.3,53.1,50.8,55.7c0,0,266.2,0.2,268.9,0.2 c46.5,0,84.3-37.7,84.3-84.3C424,133.7,387.9,96.7,342.7,95.1z"
          ></path>
          <path
            stroke-linecap="round"
            stroke-width="35"
            stroke="#004c82"
            class="st0 blue-anim"
            d="M342.7,95.1C338.1,52.9,302.4,20,258.9,20c-43.8,0-79.8,33.5-83.9,76.3c-4.6-0.8-9.4-1.2-14.2-1.2 c-36.9,0-68.3,23.8-79.7,56.8c-1.7-0.2-3.4-0.2-5.2-0.2c-30.9,0-56,25.1-56,56c0,29.2,22.3,53.1,50.8,55.7c0,0,266.2,0.2,268.9,0.2 c46.5,0,84.3-37.7,84.3-84.3C424,133.7,387.9,96.7,342.7,95.1z"
          ></path>
        </g>
      </svg>
    </div>
    <div>
      <div *ngIf="showProgressBar" class="progress-bar">
        <span [ngStyle]="{'width': percentage ? percentage + '%' : '0%'}"> </span>
      </div>
      <div *ngIf="text"> {{text}} </div>
    </div>
  </div>
  <!--  #loader-inner  -->
</div>
<!--  #loader  .loader-wrapper -->
